<template>
  <div
    class="modal-mask"
    v-if="$store.getters.USERPROFILE['product-administration']"
  >
    <section class="modal reduced">
      <div class="content">
        <!-- HEAD add product -->
        <h1>{{$t('createProduct.title')}}</h1>
      </div>
      <hr>
      <div class="content">
        <label>{{$t('createProduct.productCode')}}</label>
        <div class="row">
          <div class="demiRow">
            <input
              type="text"
              v-model="product['merchant-reference']"
            />
          </div>
          <p class="tips">{{$t('createProduct.productCodeUsedBy')}}</p>
        </div>
        <label>{{$t('products.productName')}}</label>
        <div class="row">
          <div class="demiRow">
            <input
              type="text"
              v-model="product.name"
            />
          </div>
          <p class="tips">{{$t('createProduct.usedToFindProduct')}}</p>
        </div>
        <label>{{$t('createProduct.salesChannel')}}</label>
        <div class="row">
          <div class="demiRow">
            <select v-model="product['channel-id']">
              <option
                v-for="channel in salesChannels"
                :key="channel.id"
                :value="channel.id"
              >
                {{channel['name']}} ({{channel['merchant-name']}})
              </option>
            </select>
          </div>
          <p class="tips">
            {{$t('createProduct.selectOrCreateSalesChannel')}}
          </p>
        </div>
        <br>
        <a
        v-if="$store.getters.USERPROFILE['sales-channel-administration']" 
        @click="show.modal = true">{{$t('createProduct.newSalesChannel')}}</a>
        <AddSalesChannel
          v-if="show.modal"
          @close="show.modal = false"
          @get="getSalesChannels"
          @newchannel="selectNewChannel"
        ></AddSalesChannel>
        <div class="spacer"></div>
        <hr><br>
        <div class="row">
          <button @click="addProduct()">{{$t('button.createTheProduct')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import Products from "@/services/Products.js";
import AddSalesChannel from "@/components/salesChannel/Add";
import NoAccess from "@/components/layout/NoAccess";
import getSalesChannels from "@/mixins/getSalesChannels";
export default {
  components: { AddSalesChannel, NoAccess },
  mixins: [getSalesChannels],
  data() {
    return {
      product: {
        id: "",
        name: "",
        "merchant-reference": "",
        "channel-id": "",
        archived: "false"
      },
      show: {
        modal: false
      }
    };
  },
  mounted() {
    this.getSalesChannels();
  },
  methods: {
    selectNewChannel(data) {
      this.product["channel-id"] = data;
    },
    addProduct() {
      Products.add(this.product).then(res => {
        if (res.status === 201) {
          let location = res.headers.location.split("/");
          this.product.id = location[location.length - 1];
          // Renvoyer les nouveaux products et se placer sur le dernier
          this.$emit("newproduct", this.product);
          this.$emit("close");
        }
      });
    }
  }
};
</script>